import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

/* ---------- Shared chat unread sum ----------
   Uses the same get_chat_inbox RPC as the chat inbox page. Defensive: while the
   chat migration is not live yet (PGRST202) or any fetch fails, the count
   simply stays 0 — badges must never break because of chat.
   Fetches whenever `active` turns true (e.g. drawer opened, page mounted). */
export function useChatUnread(active: boolean): number {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!active) return;
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase.rpc('get_chat_inbox');
        if (error) throw error;
        if (cancelled) return;
        const total = ((data || []) as Array<{ unread_count?: number }>).reduce(
          (sum, row) => sum + (Number(row.unread_count) || 0),
          0
        );
        setUnread(total);
      } catch {
        if (!cancelled) setUnread(0);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [active]);

  return unread;
}
